import { forwardRef } from 'react';
import { G } from '@mobily/ts-belt';
import { Box, ButtonBase, IconChevronDown16, Text } from '@stitch-fix/mode-react';
import styles from './menu.module.scss';
type MenuButtonProps = {
  count?: number;
  onClick: () => void;
  text: string;
};

/**
 * Presentational component used to display the filter and sort buttons.
 */
const MenuButton = forwardRef<HTMLButtonElement, MenuButtonProps>(({
  text,
  count,
  onClick
}, ref) => {
  const isCountShown = !G.isUndefined(count) && count !== 0;
  /** Select Box settings */
  const menuTextColor = 'blue-45';
  /** Count show settings */
  const marginRightText = isCountShown ? 0.25 : 'auto';
  const bgColorCount = 'blue-45';
  const textColor = 'white';
  /** Icon settings */
  const iconColor = 'blue-45';
  return <Box as={ButtonBase} className={styles['menu-button']} onClick={onClick} data-testid="menu-button" ref={ref} color={menuTextColor}>
        <Text height="tall" family="regular" scale="2" mr={marginRightText}>
          {text}
        </Text>
        {isCountShown && <Box as="span" className={styles['count-label']} data-testid="count-label" bgColor={bgColorCount} color={textColor}>
            <Text family="regular" height="short" scale="1">
              {count}
            </Text>
          </Box>}
        <IconChevronDown16 purpose="decorative" color={iconColor} />
      </Box>;
});
export default MenuButton;